import { useState } from "react";

export enum ChangePasswordStepEnum {
    Step1 = 1,
    NewPassword = 2
}

export default function useChangePasswordState() {
    // by using a custom hook we could include  other state to work on such as app settings state
    // also this simplifies use of dispatch by providing state methods, this would alleviate the 
    // need to use an enum for the action types
    // const [currentPassword, setCurrentPassword] = useState<string>();
    // const [newPassword, setNewPassword] = useState<string>();
    // const [confirmPassword, setConfirmPassword] = useState<string>();
    const [step, setStep] = useState<ChangePasswordStepEnum>(ChangePasswordStepEnum.Step1);
    // const [modified, setModified] = useState(false);
    // const [valid, setValid] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [newUser, setNewUser] = useState(false);
    const [forgotPasswordGuid, setForgotPasswordGuid] = useState<string>();

    return {
        // currentPassword,
        // setCurrentPassword,
        // newPassword,
        // setNewPassword,
        // confirmPassword,
        // setConfirmPassword,
        // modified,
        // setModified,
        step,
        setStep,
        showPassword,
        setShowPassword,
        newUser,
        setNewUser,
        forgotPasswordGuid,
        setForgotPasswordGuid
        // valid,
        // setValid
    };
};
